import { TileButtonsContainer, TilePlayButton } from "@/components/ui-v2";

import { AudioPreviewTileAction } from "./AudioPreviewTile";

interface AudioPreviewTileControlsProps {
  isPlaying: boolean;
  onAction: (event: React.MouseEvent, action: AudioPreviewTileAction) => void;
}

export const AudioPreviewTileControls = (
  props: AudioPreviewTileControlsProps,
) => {
  const { isPlaying, onAction } = props;

  return (
    <TileButtonsContainer>
      <TilePlayButton isPlaying={isPlaying} onAction={onAction} />
    </TileButtonsContainer>
  );
};
